<script lang="ts" setup>
import SimpleBaseDialog from '@/components/dialogs/SimpleBaseDialog.vue'

const props = withDefaults(
  defineProps<{
    isBulk?: boolean
    memberName?: string
    count?: number
    loading?: boolean
  }>(),
  { isBulk: false, memberName: '', count: 1, loading: false }
)

const emit = defineEmits<{
  action: []
  close: []
}>()

const { t } = useI18n()

const dialogTitle = computed(() =>
  props.isBulk
    ? t('business.members.remove.title_bulk', { count: props.count }, props.count)
    : t('business.members.remove.title', { name: props.memberName })
)
const description = computed(() =>
  props.isBulk ? t('business.members.remove.description_bulk') : t('business.members.remove.description')
)
</script>

<template>
  <simple-base-dialog
    :title="dialogTitle"
    :action-text="t('business.members.remove.confirm', count)"
    action-color="error"
    :cancel-text="t('global.not_now')"
    cancel-color="grey-dark"
    max-width="580"
    :loading="loading"
    data-cy="remove_members_dialog"
    @action="emit('action')"
    @close="emit('close')"
  >
    <template v-if="!isBulk" #title>
      <i18n-t keypath="business.members.remove.title" tag="span">
        <template #name>
          <span class="remove-members-name">{{ memberName }}</span>
        </template>
      </i18n-t>
    </template>
    <p class="remove-members-description">
      {{ description }}
    </p>
  </simple-base-dialog>
</template>

<style lang="scss" scoped>
.remove-members-name {
  color: $c-grey-dark;
}

.remove-members-description {
  color: $c-skribbleu;
  line-height: 1.625rem;
}
</style>
